import { useAccountStore, type AccountInfo } from '@/stores/user';
import { storeToRefs } from 'pinia';

function checkOrgGuideStatus(userInfo:any) {
  // 此处判断新旧用户登录,新用户登录需要恢复组织设置的指引step显示
  const oldUserInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo') as string) : {};
  if (userInfo.username !== oldUserInfo?.username) {
    localStorage.setItem('orgGuideStatus', 'new');
  }
}

export function useAccount() {
  const userInfo = useAccountStore();
  const { accountInfo } = storeToRefs(userInfo);
  const { saveStatus, saveAccountInfo } = userInfo;
  const RecordInfo = (source: Required<AccountInfo> | undefined, cached: boolean = true) => {
    if (!source) {
      return;
    }
    const { access_token, refresh_token, xauth_token, ...userInfo } = source;
    localStorage.setItem('access_token', access_token);
    localStorage.setItem('refresh_token', refresh_token);
    localStorage.setItem('xauth_token', xauth_token);
    checkOrgGuideStatus(userInfo);
    localStorage.setItem('userInfo', JSON.stringify(userInfo));

    if (cached) {
      saveStatus(true);
      saveAccountInfo(userInfo);
    }
  };

  const RemoveInfo = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('xauth_token');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('validator_email');
    localStorage.removeItem('visited_repo_list');
    localStorage.removeItem('invite_link');
    localStorage.removeItem('group_quota');
    localStorage.removeItem('manageable_group_num');
    // if (localStorage.getItem('cache_timeStamp')) {
    //   localStorage.removeItem('cache_timeStamp');
    // }
    if (localStorage.getItem('mask')) {
      localStorage.removeItem('mask');
    }
    saveStatus(false);
    saveAccountInfo();
  };

  return {
    RecordInfo,
    RemoveInfo,
    accountInfo
  };
}
